/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require("./js/bootstrap")
import Vue from "vue"

import {BootstrapVue, IconsPlugin} from "bootstrap-vue"
import moment from "moment"
import {store} from "./vue/store/store"

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
// moment
Vue.prototype.$moment = moment

Vue.component("nav-bar", require("./vue/components/navigation/NavBar").default)
Vue.component("nav-pagination", require("./vue/components/navigation/NavPagination").default)
Vue.component("analytic-manage", require("./vue/analytic/manage").default)

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */
const VueResources = require.context("./vue", true, /\/*\.vue$/, "sync")
VueResources.keys().map((key) => Vue.component(key.split("/").pop().split(".")[0], VueResources(key).default))

const VueResourceModules = require.context("../module", true, /\/*\.vue$/, "sync")
VueResourceModules.keys().map((key) =>
  Vue.component(key.split("/").pop().split(".")[0], VueResourceModules(key).default),
)

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
  el: "#app",
  store,
})
